export default {
  SET_DATA_VIEWS: (state, payload) => {
    state.dataViews = payload
    console.log('state', state.dataViews, payload)
  },
  SET_CURRENT_DATA_VIEW: (state, payload) => {
    state.currentDataView = payload
  },
  SET_DATA_VIEW_ITEMS: (state, payload) => {
    state.dataViewItems = payload
  },
  SET_EDIT_DATA_VIEW: (state, payload) => {
    state.editDataView = payload
  },

  SET_DATA_VIEW_LOADING: (state, payload) => {
    state.dataViewLoading = payload
  },
  SET_DATA_VIEW_ITEMS_LOADING: (state, payload) => {
    state.dataViewItemsLoading = payload
  },
  SET_CURRENT_DATA_VIEW_LOADING: (state, payload) => {
    state.currentDataViewLoading = payload
  },
  SET_EDIT_DATA_VIEW_LOADING: (state, payload) => {
    state.editDataViewLoading = payload
  },
  SET_CREATE_DATA_VIEW_LOADING: (state, payload) => {
    state.createDataViewLoading = payload
  }
};
